import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import Cookies from "js-cookie";
import { Toast } from '../components_root/ToastContext.jsx';
import { Randomcode } from "../components_root/rendom_code.js";
import { Create_account_qry } from './create_account_qry.js';
export const seo = {
    title: "Aooz.in | WhatsApp, RCS & SMS Marketing Platform for Business Growth",
    description:
        "Aooz.in offers powerful WhatsApp, RCS, and SMS marketing solutions to reach the right audience, boost engagement, and grow your business efficiently.",
    keywords:
        "AOOZ services, Aooz.in, WhatsApp marketing, RCS messaging, SMS marketing, bulk WhatsApp messages, business messaging platform, customer engagement, digital marketing tools",
    url: "https://aooz.in/whatsapp",
    image: "https://aooz.in/assets/logo.png"
};
export default function Create_account() {
    const [text, setText] = useState("");
    const { Toastshow } = Toast();
    const navigate = useNavigate();
    const [agreed, setAgreed] = useState(false);
    const [authorized, setAuthorized] = useState(false);
    const [loading, setLoading] = useState(false);
    const [slug, setSlug] = useState("");
    const [company, setCompany] = useState("");
    const [brandname, setBrandname] = useState("");
    const [domain_registration, setDomain_registration] = useState("");
    const [servicesdata, setServicesdata] = useState([]);
    const [serviceid, setServiceId] = useState("PiA8ZCxQc8oIOUkAR6x5");
    const [servicetablename, setServicetablename] = useState("companies"); 
 
    const post_Createcompany = async () => {
        const guid = Cookies.get("guid");
        if (!guid) return Toastshow("Please login first");
        if (!authorized) return Toastshow("Please authorized");
        if (!agreed) return Toastshow("Please agreed terms");
        if (!slug) return Toastshow("Please enter slug");
        if (!company) return Toastshow("Please enter company");
        if (!brandname) return Toastshow("Please enter brandname");
        const companyuid = Randomcode(26);
        try {
            setLoading(true);
            const result = await Create_account_qry({
                company,
                name: company,
                domain_registration,
                servicetablename,
                companyuid,
                serviceid,
                brandname,
                logo_uid: "null",
                banner_uid: "null",
                banner_url: "https://firebasestorage.googleapis.com/v0/b/aooz-in/o/services_icon%2Fmarketing-logo.jpg?alt=media&token=3cc70669-0862-41d2-9f12-b410d5aabcb0",
            });

            if (result.success) {
                setLoading(false);
                Toastshow("Successfully!");
              //  Cookies.set("website_company_uid", companyuid, { expires: 365, path: "/" });
              //  navigate('/billing');

            } else {
                setLoading(false);
                Toastshow("Error: " + (result.error || "Unknown error"));
            }
        } catch (error) {
            setLoading(false);
            console.error("❌ Error submitting post:", error);
            Toastshow("Error submitting post: " + error.message);
        }
    };
    const normalize = (slug = "") => {
        return slug
            .replace(/^https?:\/\//i, "")   // remove http:// or https://
            .replace(/\/+$/, "")            // remove trailing slash
            .replace(/[^a-zA-Z0-9]/g, "")   // remove ALL special characters
            .toLowerCase();                 // make lowercase
    };
    const handleChange = (e) => {
        const raw = e.target.value.toLowerCase();
         setDomain_registration(raw);
    };

    // Strict normalization: remove protocol, leading www., trailing path/slash,
    // collapse subdomains keeping last two labels (sld.tld).
    const normalizeDomain = (value) => {
        if (!value) return "";
        let v = value.toLowerCase().trim();

        // Remove protocol
        v = v.replace(/^https?:\/\//, "");

        // Remove everything after first slash (path, query, fragment)
        v = v.replace(/\/.*$/, "");

        // Remove leading "www."
        v = v.replace(/^www\./, "");

        // Remove any characters not allowed in domain labels (defensive)
        v = v.replace(/[^a-z0-9.-]/g, "");

        // Split labels and keep only last two parts (example.co.uk will become co.uk -> if you need support for multi-part TLDs, see note)
        const parts = v.split(".").filter(Boolean);
        if (parts.length === 0) return "";
        if (parts.length === 1) return parts[0]; // single label (e.g., "localhost" or incomplete)
        // If domain looks like ip address (numbers and dots), keep as-is
        const isIp = parts.every((p) => /^\d+$/.test(p));
        if (isIp) return parts.join(".");

        // Keep last two labels (sld.tld)
        v = parts.slice(-2).join(".");

        // Final defensive cleanup: only one dot between labels
        v = v.replace(/\.{2,}/g, ".");
        // Remove leading/trailing dots or hyphens
        v = v.replace(/^[.-]+|[.-]+$/g, "");

        return v;
    };

    // When user leaves the field, ensure final form like "aooz.in"
    // const handleBlur = (e) => {
    //     setDomain_registration((current) => normalizeDomain(current));
    // };

    // // Clean pasted values immediately
    // const handlePaste = (e) => {
    //     e.preventDefault();
    //     const pasted = (e.clipboardData || window.clipboardData).getData("text");
    //     const cleaned = normalizeDomain(pasted);
    //     setDomain_registration(cleaned);
    // };
    return (
        <div>

            <Helmet>
                <title>{seo.title}</title>
                <meta name="description" content={seo.description} />
                <meta name="keywords" content={seo.keywords} />
                <meta property="og:title" content={seo.title} />
                <meta property="og:description" content={seo.description} />
                <meta property="og:image" content={seo.image} />
                <meta property="og:url" content={seo.url} />
            </Helmet>

            <div className="container_roots">
                <div className="container_size_info p-3">
                    <div className="company-body p-4">
                        <div className="text-hero-sub bold">Hello</div>

                        <div className="text-h1">
                            Welcome to Aooz Web Solutions
                        </div>

                        <div className="text-h2 bold">
                            We build powerful dynamic websites with easy control panels, allowing you to update content, manage pages, and upload media galleries effortlessly.
                        </div>
                        <div className="rounded p-2 ">
                            {/* Display services */}


                            <div>
                                <table>
                                    <tr>
                                        <td>
                                            <div className="border rounded  hover">
                                                <input
                                                    className="fcap border-none p-2 text-h1 bold"
                                                    placeholder="Enter Comapny name "
                                                    value={company}
                                                    maxLength={40}
                                                    onChange={(e) => {
                                                        setCompany(e.target.value);
                                                        setSlug(normalize(normalize(e.target.value)));
                                                    }}
                                                />
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="text-h3 text-off">Brand name</td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div className="border rounded  hover">
                                                <input
                                                    maxLength={20}
                                                    value={brandname}
                                                    onChange={(e) => setBrandname(e.target.value)
                                                    }
                                                    className="border-none p-1 text-h1"
                                                    placeholder="Enter Brand name"
                                                />
                                            </div>
                                        </td>
                                    </tr>
    <tr>
                                        <td className="text-h3 text-off">Website Domain name {domain_registration}</td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div className="border rounded  hover">
                                                <input
                                                    maxLength={200}
                                                    value={domain_registration}
                                                    onChange={(e) => 
                                                        
                                                        setDomain_registration(e.target.value)
                                                    }
                                                    className="border-none p-1 text-h1"
                                                    placeholder="Enter Domain name"
                                                />
                                            </div>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>
                                            <table>
                                                <tr>
                                                    <td width={30}>
                                                        <input
                                                            type="checkbox"
                                                            checked={authorized}
                                                            onChange={() => setAuthorized(!authorized)}
                                                        />
                                                    </td>
                                                    <td>

                                                        <label>
                                                            {" "}
                                                            I authorized for company person <a className='blue' href="/terms-authorized">Terms</a>
                                                        </label>
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <table>
                                                <tr>
                                                    <td width={30}>
                                                        <input
                                                            type="checkbox"
                                                            checked={agreed}
                                                            onChange={() => setAgreed(!agreed)}
                                                        />
                                                    </td>
                                                    <td>

                                                        <label>
                                                            {" "}
                                                            I agree to the <a className='blue' href="/terms">Terms and Conditions</a>
                                                        </label>
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>

                                    <br />
                                    <tr>
                                        <td>
                                            <div
                                                onClick={() => post_Createcompany()}
                                                className="button-ui fill p-33 text-h2 cursor"
                                            >
                                                {loading ? "Loading..." : "Continue"}
                                            </div>
                                        </td>
                                    </tr>
                                </table>
                            </div>

                            
                        </div>


                    </div>

                </div>

            </div>



        </div>
    );
}
